import { LayoutAttributes } from './types';

// Tile
export const tileOptions = [
  { description: 'attribute_field_labels', value: LayoutAttributes.fieldLabels },
  { description: 'attribute_quantities', value: LayoutAttributes.quantities },
  { description: 'attribute_groups', value: LayoutAttributes.groups },
  { description: 'attribute_wide_layout', value: LayoutAttributes.wideLayout },
  { description: 'attribute_totals', value: LayoutAttributes.totals }
];
export const tileAttributeMappings = {
  compactView: 'Tile.CompactView',
  hideAggrColumns: 'Tile.HideAggrColumns',
  hideHeader: 'Tile.HideHeader',
  wideLayout: 'Tile.WideLayout',
  hideTotals: 'Tile.HideTotals'
};

// Table
export const tableOptions = [
  { description: 'attribute_field_labels', value: LayoutAttributes.fieldLabels },
  { description: 'attribute_quantities', value: LayoutAttributes.quantities },
  { description: 'attribute_groups', value: LayoutAttributes.groups },
  { description: 'attribute_totals', value: LayoutAttributes.totals },
  { description: 'attribute_suppress_repeating_rows', value: LayoutAttributes.suppressRepeatingRows }
];
export const tableAttributeMappings = {
  suppressRepeatingRows: 'Table.SuppressRepeatingRows',
  compactView: 'Table.CompactView',
  hideAggrColumns: 'Table.HideAggrColumns',
  hideHeader: 'Table.HideHeader',
  hideTotals: 'Table.HideTotals'
};

// Heatmap
export const heatmapOptions = [
  { description: 'attribute_yAxis_labels_enabled', value: LayoutAttributes.yAxisLabelsEnabled },
  { description: 'attribute_xAxis_labels_enabled', value: LayoutAttributes.xAxisLabelsEnabled }
];
export const heatmapAttributeMappings = {
  xAxisLabelsEnabled: 'Highcharts.xAxis.labels.enabled',
  yAxisLabelsEnabled: 'Highcharts.yAxis.labels.enabled'
};

export const heatmapType = 'HighchartsStyle.heatmapUseDataPointColors';

export type AttributeMappingType = Partial<typeof tileAttributeMappings & typeof tableAttributeMappings & typeof heatmapAttributeMappings>;
